<template>
  <div id="contact_outer" v-if="introduceData != null">
    <div>
      <div id="contact_left_part">
        联系邮箱：{{email}}<br>
        联系电话：{{tel}}<br>
        联系地址：{{addr}}
      </div>
    </div>
    <div>
      <div id="contact_right_part">
        <img :src="qrCodeImg">
        <div>
          扫码关注<br>
          官方微信号
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactUsDetail",
  data() {
    return {
      title: '联系我们',
      item: {
        email: 'shanghaibasketball@163.com',
        phone: '021-64375854',
        address: '上海市浦东新区泳耀路300好东方体育大厦8楼806室',
      }
    }
  },
  computed: {
    introduceData() {
      return this.$store.state.introduceData;
    },
    email() {
      return this.introduceData.email;
    },
    tel() {
      return this.introduceData.tel;
    },
    addr() {
      return this.introduceData.addr;
    },
    qrCodeImg() {
      return this.introduceData.subscription;
    }
  },
  mounted() {
  },
  methods: {

  }
}
</script>

<style scoped>
  #contact_outer {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
    margin-top: -30px;
  }

  #contact_outer > div {
    width: 40%;
    border: solid 1px #fc1a34;
    border-radius: 16px;
    min-height: 200px;
    min-width: 250px;
    margin-top: 30px;

    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
  }

  #contact_outer > div > div {
    width: 80%;
    height: 120px;
    /*background-color: yellow;*/
  }

  #contact_left_part {
    font-size: 1.5rem;
    color: #333;
    line-height: 2.5rem;
  }

  #contact_right_part {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
  }

  #contact_right_part > img {
    width: 40%;
    height: auto;
  }

  #contact_right_part > div {
    font-size: 1.5rem;
    color: #333;
    line-height: 2.5rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/introduce/ContactUsDetail.vue